import { API } from 'aws-amplify';

interface Params {
  to_email?: string;
  to_phone?: string;
  to_name?: string;
  from_name?: string;
  from_email?: string;
  invitation_body?: string;
}

interface ErrorResult {
  success: false;
  error: string;
}

interface SuccessResult {
  success: true;
  data: {
    url: string;
  };
}

type Result = SuccessResult | ErrorResult;

// Creates a dailyjs video chat room
export async function createRoom(params?: Params): Promise<Result> {
  try {
    const res = await API.post('videochatapi', '/rooms', {
      properties: {
        start_audio_off: true,
        start_video_off: true,
        enable_chat: true,
        exp: Math.floor(Date.now() / 1000) + 6000,
      },

      body: {
        ...params,
      },
    });

    if (res.success === false) {
      throw new Error(res.error);
    }

    return {
      success: true,
      data: res,
    };
  } catch (ex: any) {
    console.log(
      `Creating room failed (${ex as string}):\n  ${ex?.response?.data?.error}`
    );

    return {
      success: false,
      error:
        (ex?.response?.data?.error as string) ||
        'Something went wrong when starting the video call. Please try again.',
    };
  }
}
